import React from "react";
import styled from "styled-components";
import {
  Control,
  UseFieldArrayAppend,
  UseFieldArrayRemove,
} from "react-hook-form";
import InputField from "components/UI/InputField/InputField";
import SubmitResetNav from "components/common/form/SubmitResetNav";
import FormFieldContainer from "components/layout/style/form/FormFieldContainer";
import { UnitFieldValName } from "constant/dl_unit/dl_unit_field.constant";
import RemoveButton from "components/common/style/navigation/RemoveButton";
import AddButton from "components/common/style/navigation/AddButton";
import UnitFieldValNameSelect from "components/common/dl_unit/UnitFieldValNameSelect/UnitFieldValNameSelect";

export type FCondItem = {
  fieldName: UnitFieldValName;
  fieldValue: string;
};

export type DlGroupFormState = {
  slug: string;
  fieldConditions: FCondItem[];
};

export type FieldArrayHandlers = {
  fields: (FCondItem &
    Record<"id", string> & {
      disabled?: boolean;
    })[];
  append: UseFieldArrayAppend<DlGroupFormState, "fieldConditions">;
  remove: UseFieldArrayRemove;
};

type DlGroupFormProps = {
  control: Control<DlGroupFormState>;
  fieldArrayHandlers: FieldArrayHandlers;
  errorText?: string;
  isEditMode?: boolean;
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  onReset: () => void;
};

export const DL_GROUP_EMPTY_FORM: DlGroupFormState = {
  slug: "",
  fieldConditions: [],
};

const DlGroupForm = ({
  control,
  fieldArrayHandlers: { fields: fieldConditions, append, remove },
  errorText = "",
  isEditMode = false,
  onSubmit,
  onReset,
}: DlGroupFormProps) => {
  return (
    <DivForm>
      <form onSubmit={onSubmit}>
        <Title>{isEditMode ? "Uredi odrednicu" : "Nova odrednica"}</Title>

        <SubmitResetNav onReset={onReset} />
        <FormFieldContainer>
          <InputField name="slug" control={control} label="Slug" id="slug" />
        </FormFieldContainer>

        <DivFieldConditions>
          {fieldConditions.map((fieldCondition, ind) => (
            <div key={fieldCondition.id}>
              <FormFieldContainer>
                <UnitFieldValNameSelect
                  name={`fieldConditions.${ind}.fieldName`}
                  control={control}
                />
              </FormFieldContainer>
              <FormFieldContainer>
                <InputField
                  name={`fieldConditions.${ind}.fieldValue`}
                  control={control}
                  label="Value"
                />
              </FormFieldContainer>
              <DivRemove>
                <RemoveButton
                  variant="text"
                  onClick={() => {
                    console.log("remove ind", ind);

                    remove(ind);
                  }}
                >
                  Obriši
                </RemoveButton>
              </DivRemove>
            </div>
          ))}
          <DivAdd>
            <AddButton
              variant="text"
              onClick={() => append({ fieldName: "", fieldValue: "" })}
            >
              Dodaj
            </AddButton>
          </DivAdd>
        </DivFieldConditions>

        {errorText !== "" && <ErrorText>{errorText}</ErrorText>}

        <DivNav>
          <SubmitResetNav onReset={onReset} />
        </DivNav>
      </form>
    </DivForm>
  );
};

const DivForm = styled.div`
  margin-top: 0rem;
`;

const DivFieldConditions = styled.div`
  margin-top: 3rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const DivRemove = styled.div`
  margin-top: 0.75rem;
`;

const DivAdd = styled.div`
  margin-top: 0.75rem;
`;

const DivNav = styled.div`
  margin-top: 2rem;
  display: flex;
  gap: 0.75rem;
`;

const Title = styled.h2`
  margin: 0 0 1rem;
`;

const ErrorText = styled.div`
  margin-top: 0.5rem;
  color: #b00020;
  font-weight: 600;
`;

export default DlGroupForm;
